import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault('Asia/Taipei');

/**
 * Formats a date string or Date object to YYYY/MM/DD hh:mm:ss format in Asia/Taipei timezone
 * @param date - Date string or Date object to format
 * @returns Formatted date string in YYYY/MM/DD hh:mm:ss format
 */
export const formatDateTime = (date: number | Date): string => {
  return dayjs(date).tz('Asia/Taipei').format('YYYY/MM/DD HH:mm:ss');
};

/**
 * Formats a date string or Date object to YYYY/MM/DD format (date only) in Asia/Taipei timezone
 * @param date - Date string or Date object to format
 * @returns Formatted date string in YYYY/MM/DD format
 */
export const formatDate = (date: number | Date): string => {
  return dayjs(date).tz('Asia/Taipei').format('YYYY/MM/DD');
};
